import { adminAPIService, newhopeAPIService } from './index'

const route = 'banner' // 'banners'

export default {
  getList(page = 1, size = 50) {
    const params = { page, size }
    return newhopeAPIService({
      url: 'banners',
      method: 'get',
      params,
    })
  },
  getDetail(id) {
    return newhopeAPIService({
      url: `banners/${id}`,
      method: 'get',
    })
  },
  create(banner) {
    return newhopeAPIService({
      url: 'banners',
      method: 'post',
      data: banner,
    })
  },
  updateDetail(bannerDetail, id) {
    const body = `json=${encodeURIComponent(JSON.stringify(bannerDetail))}`
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'post',
      data: body,
    })
  },
}
